import { keyBy } from '@src/utils/functions/utils'
import Product from '.'
import productHelper from '../../helpers/productHelper'
import cartesianProductOf from '../../utils/cartesianProductOf'
import { getURLStringFromInputString } from '../../utils/getURLStringFromInputString'
import { ProductImageOption } from '../ProductImage'

export function getFilteredImages(product: Product) {
  const MAX_IMAGES_TO_KEEP = 2

  const allPossibleImageOptionName = productHelper.getAllPossibleImageOptionName(product)

  const allPossibleImageOptionNameInSequence: string[] = productHelper
    .getProductOptionNameSequence(product)
    .filter(productOptionName => allPossibleImageOptionName.has(productOptionName))

  const optionKeyVsImageCountMap: Record<string, number> = {}
  return product.images.filter(image => {
    const optionKeys = generateProductImageOptionKeys(image.options, allPossibleImageOptionNameInSequence)

    for (const optionKey of optionKeys) {
      const fullOptionKey = `${optionKey}-${image.image.description}`
      const imageCount = optionKeyVsImageCountMap[fullOptionKey] || 0
      const newImageCount = imageCount + 1
      if (newImageCount <= MAX_IMAGES_TO_KEEP) {
        optionKeyVsImageCountMap[fullOptionKey] = newImageCount
        return true
      }
    }
    return false
  })
}

const generateProductImageOptionKeys = (
  productImageOptions: ProductImageOption[],
  allPossibleImageOptionNameInSequence: string[],
) => {
  const productImageOptionByName = keyBy(productImageOptions, productImageOption =>
    getURLStringFromInputString(productImageOption.name),
  )

  const allValuesInSeQ = allPossibleImageOptionNameInSequence.map(productOptionName => {
    return productImageOptionByName[productOptionName]?.values || ['EMPTY']
  })

  const productOptionValueCombinations = cartesianProductOf(allValuesInSeQ)

  return productOptionValueCombinations.map(productOptionValueCombination => productOptionValueCombination.join('-'))
}
